import { useDispatch, useSelector } from 'react-redux';
import {loadPlayerNote, loadPlayersNoteType, updatePlayerNote}  from '../actions/playerNotes';
import { RootState } from '../reducers';
import { loadPlayerParticipation } from 'store/actions';

export const usePlayerParticipationState = () => {
  const  playerParticipationData  = useSelector((state: RootState) => state.playerParticipationData);
  return {playerParticipationData};
};

export const usePlayerParticipationDispatch = () => {
  const dispatch = useDispatch();
  return {
        loadPlayerParticipation: (gameId: string, withLoader: boolean) => dispatch(loadPlayerParticipation(gameId, withLoader)),
  };
};